import React from 'react'
import { SvgGraphic, SvgGraphicProps } from '../../design-system'

export const DetailIcon = (props: SvgGraphicProps) => (
  <SvgGraphic viewBox="0 0 68 47" fill="none" {...props}>
    <path
      d="M66.08 29.747H1.035V1"
      stroke="currentColor"
      strokeWidth={2}
      strokeMiterlimit={10}
    />
    <path
      d="M66.264 29.81l-25.45-15.709m25.45 15.709l-25.45 15.709"
      stroke="currentColor"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </SvgGraphic>
)

export const DetailIconSmall = (props: SvgGraphicProps) => (
  <SvgGraphic viewBox="0 0 33 23" fill="none" {...props}>
    <path
      d="M31.754 14.143H2.016V1"
      stroke="currentColor"
      strokeWidth={2}
      strokeMiterlimit={10}
    />
    <path
      d="M31.839 14.172L20.203 6.99M31.839 14.172l-11.636 7.182"
      stroke="currentColor"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </SvgGraphic>
)
